module.exports = __webpack_public_path__ + "static/blog-mobile-712a2b6596c5c138a0bf7f3c852778c4.png";